import React from 'react';

// eslint-disable-next-line import/prefer-default-export
export const ConfigContext = React.createContext({
  agent: 'Technician',
  task: ''
});
